// extracted by mini-css-extract-plugin
export default {"container":"PX-z","title":"QX-z","link":"RX-z"};